import { render, staticRenderFns } from "./SpadD_Items.vue?vue&type=template&id=b7d3deea"
import script from "./SpadD_Items.vue?vue&type=script&lang=js"
export * from "./SpadD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports